import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import Motion from '@/app/components/Motion';

import MobileFeature from './MobileFeature';

const HostingParty = () => {
  const t = useTranslations();
  return (
    <MobileFeature
      title="features_tab_5_label"
      image={{
        alt: 'tab_item_host_party_img_1_aria_label',
        src: 'blue-sky/home/host-party-primary',
      }}
    >
      <div className="relative hidden lg:block" data-cy="hosting-party">
        <Image
          alt={t('tab_item_host_party_img_1_aria_label')}
          src="blue-sky/home/host-party-primary"
          height={431}
          width={575}
          className="rounded-lg object-cover"
        />
      </div>
      <div
        className={cx(
          'absolute bottom-16 left-1/2 w-[80vw] max-w-[300px] -translate-x-1/2 flex-col gap-y-6',
          'lg:relative lg:bottom-auto lg:left-0 lg:flex lg:w-auto lg:max-w-none lg:translate-x-0',
        )}
      >
        <div className="hidden gap-6 lg:flex">
          <div className="grid grid-cols-1 grid-rows-1 self-end">
            <Image
              alt=""
              className="col-start-1 col-end-2 row-start-1 row-end-2 rounded-lg"
              src="blue-sky/home/host-party-mask-1"
              width={300}
              height={248}
            />
            <Image
              alt={t('daytime_stress_image_alt')}
              className="col-start-1 col-end-2 row-start-1 row-end-2 rounded-lg"
              src={t('daytime_stress_app_ui')}
              format="png"
              width={300}
              height={248}
            />
          </div>
          <div>
            <Image
              alt={t('tab_item_host_party_img_2_aria_label')}
              className="rounded-lg"
              src="blue-sky/home/host-party-secondary"
              width={220}
              height={294}
            />
          </div>
        </div>
        <div className="hidden grid-cols-1 grid-rows-1 lg:grid">
          <Image
            alt=""
            className="col-start-1 col-end-2 row-start-1 row-end-2 rounded-lg"
            src="blue-sky/home/host-party-mask-2"
            width={345}
            height={266}
          />
          <Image
            alt={t('daytime_heartrate_image_alt')}
            className="col-start-1 col-end-2 row-start-1 row-end-2 self-center rounded-lg"
            src={t('daytime_heartrate_app_ui')}
            format="png"
            width={345}
            height={266}
          />
        </div>
        <Motion
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, type: 'tween', delay: 0.5 }}
          className="grid grid-cols-1 grid-rows-1 lg:hidden"
        >
          <Image
            alt=""
            className="col-start-1 col-end-2 row-start-1 row-end-2 rounded-lg"
            src="blue-sky/home/host-party-mask-mobile"
            width={300}
            height={277}
          />
          <Image
            alt={t('daytime_heartrate_image_alt')}
            className="col-start-1 col-end-2 row-start-1 row-end-2 self-center rounded-lg"
            src={t('daytime_heartrate_app_ui')}
            format="png"
            width={300}
            height={277}
          />
        </Motion>
      </div>
    </MobileFeature>
  );
};

export default HostingParty;
